import { ICONS } from "../variables/icons";

/**
 * Resolves an icon by key. Returns the raw SVG markup if `key` is already an
 * inline SVG string, otherwise looks up `ICONS[KEY_UPPERCASED]`.
 */
export const getSvgIconValue = (key: string | ICONS): string => {
  if (!key || key.startsWith("<svg")) return key;
  return ICONS[key.toUpperCase() as keyof typeof ICONS] ?? "";
};
